/** Every pill-shaped control in the app, so a radius or a disabled state means one thing everywhere. */
type PillTone = 'solid' | 'accent' | 'danger' | 'quiet' | 'quiet-strong' | 'quiet-danger' | 'ghost';

type PillSize = 'sm' | 'md';

const BASE = 'rounded-pill transition-colors disabled:cursor-not-allowed disabled:opacity-50';

const SIZES: Readonly<Record<PillSize, string>> = {
  sm: 'px-3.5 py-1.5 text-xs',
  md: 'px-4 py-2.5 text-sm',
};

const TONES: Readonly<Record<PillTone, string>> = {
  solid: 'bg-content text-inverted font-semibold',
  accent: 'bg-accent hover:bg-accent-hover text-inverted font-semibold',
  danger: 'bg-danger hover:bg-danger-hover text-inverted font-semibold',
  quiet: 'border-line text-secondary hover:bg-surface-hover border font-medium',
  'quiet-strong': 'border-line text-content hover:bg-surface-hover border font-medium',
  'quiet-danger': 'border-line text-danger hover:bg-danger-subtle border font-medium',
  ghost: 'text-secondary hover:text-content font-medium',
};

export const pillButton = (tone: PillTone, size: PillSize = 'md'): string =>
  `${BASE} ${SIZES[size]} ${TONES[tone]}`;
